import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AngularLibraryBootstrapModule } from '../../angular-library-bootstrap.module';
import { AngularDatepickerComponent } from './angular-datepicker.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AngularLibraryBootstrapModule,
        ReactiveFormsModule
    ],
    declarations: [AngularDatepickerComponent],
    exports: [AngularDatepickerComponent],
    providers: []
})
export class AngularDatepickerModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/datepicker/angular-datepicker.module.ts